<ng-container *ngIf="!isCallbackUrl(); else loading">
  <app-hvb-header></app-hvb-header>
  <div class="section-1">
    <img alt="circle depiction" class="circle-image"
         src="../../../assets/img/start-page/section-1-foreground.png">
    <h2 class="title">
      {{'startPage.section1.title1' |translate}}<br>
      {{'startPage.section1.title2' |translate}}<br>
      <span>{{'startPage.section1.title3' |translate}}</span><br>
    </h2>
    <p class="subtitle">
      {{'startPage.section1.subtitle1'|translate}}
      <br><br>
      {{'startPage.section1.subtitle2'|translate}}
    </p>
    <div class="button-container">

      <div class="signup-container">
        <span>{{'startPage.section1.aboveButtonTextSignUp'|translate}}</span>
        <a href="assets/documents/2_Zulassungsantrag_Mitgliedschaft_Hanseatische_Versicherungsboerse_e.V._-_Stand_22.06.2023.pdf" target=”_blank”>
          <button mat-raised-button>{{'startPage.section1.join'|translate}}
            <img alt="arrow" src="../../../assets/svg-icons/arrow_right.svg">
          </button>
        </a>
      </div>
      <div class="login-container">
        <span>{{'startPage.section1.aboveButtonTextLogin'|translate}}</span>
        <button (click)="login()" mat-stroked-button>{{'startPage.section1.login'|translate}}</button>
      </div>
    </div>
  </div>
  <div class="section-2">
    <h3 class="title">{{'startPage.section2.title' |translate}}</h3>
    <p class="subtitle">{{'startPage.section2.subtitle'|translate}}</p>
    <div class="outer-container">
      <div class="d-flex flex-column">
        <span class="title">{{'startPage.section2.leftColumnTitle'|translate}}</span>
        <span class="text"> {{'startPage.section2.leftColumnText'|translate}}</span>
      </div>
      <div class="d-flex flex-column">
        <span class="title">{{'startPage.section2.rightColumnTitle'|translate}}</span>
        <span class="text"> {{'startPage.section2.rightColumnText'|translate}}</span>
      </div>
    </div>

    <img alt="city of Hamburg" src="../../../assets/img/start-page/Hamburg_Bild.jpg">
  </div>
  <div class="section-3">
    <h3 class="title">
      {{'startPage.section3.title' | translate}}
    </h3>
    <p class="subtitle">
      {{'startPage.section3.subtitle'| translate}}
    </p>
    <div class="d-flex flex-row justify-content-between gap-5">
      <ng-container *ngFor="let i of [1,2,3,4]">
        <div class="d-flex flex-column gap-1">
          <div class="d-flex flex-row gap-3">
            <div class="image-container">
              <img alt="icon {{i}}" src="../../../assets/img/start-page/HVB_Website_Icon_{{i}}.svg">
            </div>
            <span>{{'startPage.section3.' + i + '.title'|translate}}</span>
          </div>
          <span class="image-description">
            {{'startPage.section3.' + i + '.text'|translate}}
          </span>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="section-4">
    <div class="outer-container">
      <ng-container *ngFor="let i of [1,2,3]">
        <div class="inner-container">
          <img alt="" src="../../../assets/img/start-page/HVB_profile_picture_{{i}}.png">
          <span class="name">{{'startPage.section4.' + i + '.name' |translate}}</span>
          <span class="title">{{'startPage.section4.' + i + '.title' | translate}}</span>
          <span class="text">"{{'startPage.section4.' + i + '.quote'|translate}}"</span>
        </div>
      </ng-container>
    </div>

    <hr>

    <div class="title">
      {{'startPage.section4.title'|translate}}
    </div>
    <div class="text">
      {{'startPage.section4.subtitle'|translate}}
    </div>
    <img alt="computer" src="../../../assets/img/start-page/HVB_demo_computer.png">
  </div>
  <hvb-footer></hvb-footer>
</ng-container>

<ng-template #loading >
  <div class="d-flex justify-content-center align-items-center h-100 w-100 pt-4">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>

